<div
  class="ml-auto hidden items-center justify-end space-x-4 lg:flex lg:space-x-8"
>
  <!-- Search Component -->
  <!--  <dhp-search (searchStateChange)="onSearchStateChange($event)"></dhp-search>-->

  <!-- Language dropdown for desktop -->
  <div class="relative hidden lg:block">
    <button
      class="flex items-center text-primary-text transition-colors duration-300"
      [attr.aria-expanded]="
        dialogService.isOpen('languageMenu') ? 'true' : 'false'
      "
      [attr.aria-label]="'components.header.languageSelector' | translate"
      (click)="toggleDropdown('languageMenu', $event)"
    >
      <img
        class="h-5 w-5"
        src="assets/icons/globe.svg"
        alt="{{ 'components.header.changeLanguage' | translate }}"
      />
    </button>
    @if (isDropdownOpen('languageMenu')) {
      <div
        class="absolute right-0 z-50 mt-2 w-[120px] origin-top-right transform rounded-xl border border-secondary-border bg-primary-background p-2 transition-all duration-200 ease-out"
        (clickOutside)="dialogService.toggle('languageMenu', false)"
        dhpClickOutside
      >
        @for (lang of enabledLanguages(); track lang) {
          <button
            class="flex w-full items-center justify-between px-4 py-2 text-left text-base leading-normal font-medium text-primary-text transition-colors duration-200 hover:text-orange-500"
            [class.font-medium]="currentLanguage === lang"
            (click)="selectLanguage(lang)"
          >
            {{ lang | uppercase }}
            @if (currentLanguage === lang) {
              <img
                class="h-4 w-4 text-primary-text"
                src="assets/icons/check.svg"
                alt="{{ 'components.header.selectLanguage' | translate }}"
              />
            }
          </button>
        }
      </div>
    }
  </div>

  <!-- Conditional buttons based on authentication -->
  @if (isAuthenticated()) {
    <!-- Profile Circle with Logout Dialog -->
    <div class="relative">
      <dhp-profile-icon
        [user]="currentUser()"
        (iconClicked)="toggleDropdown('logout', $event)"
      ></dhp-profile-icon>
      <!-- Logout Dialog -->
      @if (dialogService.isOpen('logout')) {
        <div
          class="absolute right-0 z-50 mt-2 flex w-80 origin-top-right transform flex-col gap-4 rounded-xl border border-secondary-border bg-primary-background p-6 transition-all duration-200 ease-out"
          [class.scale-95]="!dialogService.isOpen('logout')"
          [class.opacity-0]="!dialogService.isOpen('logout')"
          (clickOutside)="dialogService.toggle('logout', false)"
          dhpClickOutside
          role="menu"
          aria-orientation="vertical"
        >
          <!-- Organization Badge -->
          <div class="inline-flex">
            <div
              class="inline-flex items-center justify-center rounded-2xl bg-alternate-background px-3 py-1"
            >
              <span
                class="text-xs font-medium"
                [ngClass]="{
                  'text-secondary-text italic': !organization,
                  'text-alternate-text': organization,
                }"
              >
                {{
                  organization ??
                    ('components.header.noOrganization' | translate)
                }}
              </span>
            </div>
          </div>
          <!-- User Profile Section -->
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-3 py-2">
              <!-- Profile Circle -->
              <div class="flex items-center">
                <dhp-profile-icon
                  [user]="currentUser()"
                  (click)="navigateProfile()"
                ></dhp-profile-icon>
              </div>
              <!-- User Info -->
              <div class="flex-1">
                <div
                  class="text-base leading-normal font-medium text-primary-text"
                >
                  {{ userName ?? ('components.header.noUsername' | translate) }}
                </div>
                <div
                  class="text-sm leading-[21px] font-normal text-primary-text"
                >
                  {{ userEmail }}
                </div>
              </div>
            </div>
            <!-- Profile Button -->
            <button
              class="w-full rounded-[40px] bg-secondary-background px-5 py-2 text-base leading-normal font-normal text-primary-text transition-all duration-200 hover:bg-neutral-200"
              [routerLink]="['/account']"
              (click)="dialogService.toggle('logout', false)"
            >
              {{ 'components.header.profileSettings' | translate }}
            </button>
          </div>
          <!-- Divider -->
          <div class="h-px bg-secondary-border"></div>
          <!-- Menu Items -->
          <button
            class="py-2 text-left text-base leading-normal font-medium text-primary-text transition-colors duration-200 hover:text-orange-500"
            [routerLink]="['/organization']"
            (click)="dialogService.toggle('logout', false)"
          >
            {{ 'components.header.organization' | translate }}
          </button>
          <button
            class="py-2 text-left text-base leading-normal font-medium text-primary-text transition-colors duration-200 hover:text-orange-500"
            [routerLink]="['/help']"
            (click)="dialogService.toggle('logout', false)"
          >
            {{ 'components.header.helpAndInfo' | translate }}
          </button>
          <button
            class="py-2 text-left text-base leading-normal font-medium text-primary-text transition-colors duration-200 hover:text-orange-500"
            (click)="logout()"
          >
            {{ 'components.header.logout' | translate }}
          </button>
        </div>
      }
    </div>
  } @else {
    <!-- Unauthenticated view -->
    <button class="btn-secondary btn" [routerLink]="['/auth/register']">
      {{ 'components.header.register' | translate }}
    </button>
    <div class="inline-flex h-12 items-center gap-4">
      <button
        class="inline-flex items-center justify-center text-base font-medium text-primary-text transition-colors duration-300 hover:text-orange-500"
        [routerLink]="['/auth/login']"
        [queryParams]="{ returnUrl: getReturnUrl }"
      >
        {{ 'components.header.login' | translate }}
      </button>
    </div>
  }
</div>
